<template>
  <div v-show="adminLoginStatus">
    <el-row class="siteList">
      <el-col class="siteBox" :span="8">
        <router-link to="/group">
          <el-card class="site">
            <div class="box">
              <span class="chineseName">金豐集團</span><br />
              <span class="englishName">KINGFONG</span>
            </div>
          </el-card>
        </router-link>
      </el-col>
      <el-col class="siteBox" :span="8">
        <router-link to="/insurance-broker">
          <el-card class="site">
            <div class="box">
              <span class="chineseName">金豐保險經紀人</span><br />
              <span class="englishName">KINGFONG INSURANCE BROKERS</span>
            </div>
          </el-card>
        </router-link>
      </el-col>
      <el-col class="siteBox" :span="8">
        <router-link to="/certificate">
          <el-card class="site">
            <div class="box">
              <span class="chineseName"
                >企業勞動法務人員能力鑑定證書培訓及考證查詢系統</span
              ><br />
            </div>
          </el-card>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { CheckAdminLogin } from '@/assets/js/api';

export default {
  data() {
    return {
      adminLoginStatus: false,
    };
  },
  components: {},
  created() {
    CheckAdminLogin()
      .then((res) => {
        let admin = sessionStorage.getItem('_admin');
        const checkStatus = res.data.data.loginStatus;
        sessionStorage.setItem('_lgists', checkStatus ? 1 : 0);

        if (!checkStatus) {
          this.$router.push('/login');
        } else {
          // 開發環境
          if (res.data.data.devEnv) {
            admin = 'kingfongAdmin';
            sessionStorage.setItem('_admin', admin);
          }

          this.adminLoginStatus = true;
          if (admin !== 'kingfongAdmin') {
            this.$router.push('/certificate');
          }
        }
      })
      .catch((err) => {
        this.$notify.error({
          title: '錯誤',
          message: err.response.data.message,
        });
      });
  },
};
</script>

<style lang="scss" scoped>
.siteList {
  height: 100vh;
  display: flex;
  align-items: center;
  .siteBox {
    .site {
      cursor: pointer;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      margin: 0 auto;
      .box {
        display: inline-block;
        text-align: left;
        margin: 0 auto;
        color: #002f7a;
        .chineseName {
          font-weight: bold;
          font-size: 3rem;
        }
        .englishName {
          font-weight: bold;
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
